import React from "react";
import { Form, Row, Col, InputNumber, Divider } from "antd";

const PunchPressTemplateMetaForm = ({ prefix }) => {
    return (
        <>
            <Divider orientation="left">Punch Press</Divider>
            <Row gutter={25}>
                <Col md={12} xs={24}>
                    <Form.Item
                        label="Rejected Count"
                        name={[prefix, "rejected_count"]}
                        rules={[
                            {
                                required: true,
                                message: "Please input Rejected Count...!",
                            },
                        ]}
                    >
                        <InputNumber
                            defaultValue={0}
                            precision={0}
                            style={{ width: "100%" }}
                        />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item
                        label="Planned down time"
                        name={[prefix, "planned_down_time"]}
                    >
                        <InputNumber
                            addonAfter="minutes"
                            defaultValue={0}
                            precision={0}
                            style={{ width: "100%" }}
                        />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item
                        label="Planned Production Count"
                        name={[prefix, "planned_production_count"]}
                        rules={[
                            {
                                required: true,
                                message: "Please input Planned production count number...!",
                            },
                        ]}
                    >
                        <InputNumber
                            defaultValue={0}
                            precision={0}
                            style={{ width: "100%" }}
                        />
                    </Form.Item>
                </Col>

                <Col md={12} xs={24}>
                    <Form.Item
                        label="Part weight"
                        name={[prefix, "part_weight"]}
                        rules={[
                            {
                                required: true,
                                message: "Please input Part weight number...!",
                            },
                        ]}
                    >
                        <InputNumber
                            addonAfter="gm"
                            defaultValue={0}
                            precision={2}
                            style={{ width: "100%" }}
                        />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item
                        label="Press Cycle"
                        name={[prefix, "press_cycle"]}
                        rules={[
                            {
                                required: true,
                                message: "Please input Press cycle number...!",
                            },
                            {
                                type: "number",
                                min: 1,
                                message: "Press Cycle must be at least 1",
                            },
                        ]}
                    >
                        <InputNumber
                            defaultValue={0}
                            precision={0}
                            style={{ width: "100%" }}
                        />
                    </Form.Item>
                </Col>
                <Col md={12} xs={24}>
                    <Form.Item
                        label="Wages per hour"
                        name={[prefix, "wages_per_hour"]}
                        rules={[
                            {
                                required: true,
                                message: "Please input Wages per hour...!",
                            },
                        ]}
                    >
                        <InputNumber
                            addonBefore="₹"
                            addonAfter=""
                            precision={undefined}
                            defaultValue={0}
                            style={{ width: "100%" }}
                            placeholder="Wages per hour"
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default PunchPressTemplateMetaForm;
